import { Button, HStack, Text } from "@chakra-ui/react";
import React from "react";
import { LogoIcon } from "../../icons/LogoIcon";

export const NavBar = () => {
  return (
    <HStack
      display={["none", "none", "flex"]}
      position="fixed"
      top={0}
      zIndex={99999}
      bgColor="primary.1000"
      py="45px"
      px="10%"
      h="10vh"
      w="full"
      borderBottom="0.5px solid"
      borderColor="primary.800"
      justifyContent="flex-end"
      alignItems="center"
      gap="20px"
    >
      <LogoIcon h={24} w={24} mr="auto" />
      <Button
        variant="unstyled"
        size="xs"
        _hover={{ bgColor: "primary.800" }}
        _active={{ bgColor: "primary.700" }}
        fontSize="smaller"
      >
        <a href="#about" style={{ padding: "20px 20px",color:"#fff" }}>
          Quiero viajar
        </a>
      </Button>
      <Button
        variant="unstyled"
        size="xs"
        _hover={{ bgColor: "primary.800" }}
        _active={{ bgColor: "primary.700" }}
        fontSize="smaller"
      >
        <a href="#driver" style={{ padding: "20px 20px",color:"#fff" }}>
          Quiero conducir
        </a>
      </Button>
      <Button
        variant="unstyled"
        size="xs"
        fontSize="smaller"
        _hover={{ bgColor: "primary.800" }}
        _active={{ bgColor: "primary.700" }}
      >
        <a href="#corporations" style={{ padding: "20px 20px",color:"#fff" }}>
          Empresas
        </a>
      </Button>
      <Text
        bgColor="white"
        size="xs"
        color="primary.800"
        fontSize="smaller"
        py={2}
        px={4}
        fontWeight="semibold"
        rounded="md"
      >
        <a href="#download">Descargar ViajáYa</a>
      </Text>
    </HStack>
  );
};
